export default __webpack_public_path__ + "static/media/bell.a1d87fc2.svg";